<!-- Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. -->
<div class="hover-over-content-modal-container">
	<dialog-titlebar [title]="data.title" [showIconButton]="false"></dialog-titlebar>
	<mat-dialog-content>
		<div class="hover-over-content-modal-content">
			<span class="content-dialog-title">{{ data.content[0] }}</span>
			<ng-container [formGroup]="tooltipContentForm">
				<checkbox-list formControlName="tooltipContent" [checkboxSide]="'left'">
					<checkbox-set
						[label]="'ALL'"
						class="all-checkbox"
						[ids]="checkboxListCustomAllId$ | async"
					></checkbox-set>

					<checkbox-list-item
						*ngFor="let modelObject of checkboxListData$ | async"
						[id]="modelObject.id"
						[label]="modelObject.label"
					>
					</checkbox-list-item>
				</checkbox-list>
				<ng-container *ngIf="customFieldsList$ | async as customFieldsList">
					<div class="custom-fields" *ngIf="customFieldsList.length">
						<mat-radio-group class="custom-fields-radio-container" formControlName="showAllcustomFields">
							<mat-radio-button class="custom-fields-radio-item" [value]="true">{{
								data.content[1]
							}}</mat-radio-button>
							<mat-radio-button class="custom-fields-radio-item" [value]="false"
								>{{ data.content[2] }}
							</mat-radio-button>
						</mat-radio-group>

						<checkbox-list
							formControlName="customFieldContent"
							checkboxSide="left"
							class="custom-fields-list"
						>
							<checkbox-list-item
								*ngFor="let customField of customFieldsList"
								[id]="customField.id"
								[label]="customField.label"
							>
							</checkbox-list-item>
						</checkbox-list>
					</div>
				</ng-container>
			</ng-container>
		</div>
	</mat-dialog-content>

	<button-footer
		mat-dialog-actions
		(buttonSaveOrClose)="onButtonSaveSelect()"
		[saveOrCloseButtonText]="data.yesButtonText"
	>
		<button leftButton mat-button color="primary" (click)="onButtonCloseSelect()" automationId="cancel">
			{{ data.noButtonText }}
		</button>
	</button-footer>
</div>
